<div class="brand">
  <img src="assets/images/carelflex-logo.png" alt="Carelflex"/>
</div>

<nav class="nav">
  <a class="nav-item" [routerLink]="CONSTANTS.ROUTES.MISSION_SELECTION" routerLinkActive="active">
    <ng-icon name="heroMapPin" size="22"/>
    <span>{{ 'MISSIONS.LABEL' | translate }}</span>
  </a>

  <a class="nav-item" [routerLink]="CONSTANTS.ROUTES.CONTAINERS" routerLinkActive="active">
    <ng-icon name="heroTruck" size="22"/>
    <span>{{ 'CONTAINERS.LABEL' | translate }}</span>
  </a>

  <a class="nav-item" [routerLink]="CONSTANTS.ROUTES.TEAMS" routerLinkActive="active">
    <ng-icon name="heroUsers" size="22"/>
    <span>{{ 'TEAMS.LABEL' | translate }}</span>
  </a>

  <a class="nav-item" [routerLink]="CONSTANTS.ROUTES.NEW_MISSION" routerLinkActive="active">
    <ng-icon name="heroPlusCircle" size="22"/>
    <span>{{ 'NEW_MISSION.LABEL' | translate }}</span>
  </a>

  @if (!!amountOfAlerts) {
    <a class="nav-item" [routerLink]="CONSTANTS.ROUTES.ALERTS_VIEW" routerLinkActive="active">
      <span class="icon-with-badge">
        <ng-icon name="heroBell" size="22"/>
        <span class="badge">{{ amountOfAlerts }}</span>
      </span>
      <span>{{ 'UI.ALERTS' | translate }}</span>
    </a>
  }
</nav>

<div class="footer">
  <button type="button" class="nav-item" (click)="logout()">
    <ng-icon name="heroArrowRightStartOnRectangle" size="22"/>
    <span>{{ 'LOGOUT' | translate }}</span>
  </button>

  <img class="logo" src="assets/images/arkema-logo.png" alt="Arkema"/>
</div>
